/* const INITIAL_VALUES = { 
  tab: 'general',
  tabDocument: 'general',
  tabStatistic: 'training',
  url: 'http://localhost:8000',
  api: 'http://localhost:8001',
  front: 'http://localhost:3000',
  idUser: null,
  page: null,
};  */ 
 
const INITIAL_VALUES = { 
  tab: 'general',
  tabDocument: 'general',
  tabStatistic: 'training',
  url: 'https://app.postgrad.fr',
  api: 'https://api.postgrad.fr',
  front: 'https://app.postgrad.fr',
  idUser: null,
  page: null,
};  

/* const INITIAL_VALUES = { 
  tab: 'general',
  tabDocument: 'general',
  tabStatistic: 'training',
  url: 'https://test.postgrad.fr',
  api: 'https://testapi.postgrad.fr',
  front: 'https://testquiz.postgrad.fr',
  idUser: null,
  page: null,
};   */
   
export const CHANGE_TAB = 'CHANGE_TAB';
export const RETURN_PAGE = 'RETURN_PAGE';
export const CHANGE_DOCUMENT_TAB = 'CHANGE_DOCUMENT_TAB';
export const CHANGE_TAB_STATISTIC = 'CHANGE_TAB_STATISTIC';

const SettingsReducer = (state = INITIAL_VALUES, action) => {
  // console.log('action', action.payload);

  switch (action.type) {
    case CHANGE_TAB:
      return { ...state, tab: action.payload };
    case CHANGE_DOCUMENT_TAB:
      return { ...state, tabDocument: action.payload };
    case CHANGE_TAB_STATISTIC:
      return { ...state, tabStatistic: action.payload };
    case RETURN_PAGE:
      return { ...state, idUser: action.payload.idUser, page: action.payload.page };
    default:
      return state;
  }
};

export default SettingsReducer;
